module.exports = __webpack_public_path__ + "static/img/20_pro.f53f60c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/rz/20_pro.jpg
// module id = UGSL
// module chunks = 0